import api from './api';
import publicApi from './publicApi';

export const tableService = {
  // Admin Table Management
  getAdminTables: async (outletId = null) => {
    const params = outletId ? { outlet_id: outletId } : {};
    const response = await api.get('/tables/admin/tables', { params });
    return response.data;
  },

  createTable: async (tableData) => {
    const formData = new FormData();
    Object.keys(tableData).forEach(key => {
      if (tableData[key] !== null && tableData[key] !== undefined) {
        formData.append(key, tableData[key]);
      }
    });
    
    const response = await api.post('/tables/admin/tables', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateTable: async (tableId, tableData) => {
    const formData = new FormData();
    Object.keys(tableData).forEach(key => {
      if (tableData[key] !== null && tableData[key] !== undefined) {
        formData.append(key, tableData[key]);
      }
    });
    
    const response = await api.put(`/tables/admin/tables/${tableId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteTable: async (tableId) => {
    const response = await api.delete(`/tables/admin/tables/${tableId}`);
    return response.data;
  },

  // Public Table Operations
  getPublicTables: async (outletId) => {
    const response = await api.get(`/tables/public/outlets/${outletId}/tables`);
    return response.data;
  },

  checkTableAvailability: async (availabilityData) => {
    const response = await api.post('/tables/public/check-availability', availabilityData);
    return response.data;
  },

  createTableReservation: async (reservationData) => {
    const response = await api.post('/tables/public/reservations', reservationData);
    return response.data;
  },

  createReservationRequest: async (requestData) => {
    const response = await publicApi.post('/public/booking-request', requestData);
    return response.data;
  },

  // Admin Reservation Management
  getAdminReservations: async (outletId = null, status = null) => {
    const params = {};
    if (outletId) params.outlet_id = outletId;
    if (status) params.status = status;
    
    const response = await api.get('/reservations/admin', { params });
    return response.data;
  },

  updateReservationStatus: async (reservationId, status, adminNotes = null) => {
    const formData = new FormData();
    formData.append('status', status);
    if (adminNotes !== null) {
      formData.append('admin_notes', adminNotes);
    }
    
    const response = await api.patch(`/tables/admin/reservations/${reservationId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Public Table Order Access
  getTableOrderPage: async (uniqueString) => {
    const response = await publicApi.get(`/tables/public/table-order/${uniqueString}`);
    return response.data;
  },

  // Reservation Availability Check
  checkAvailability: async (date) => {
    const response = await api.get(`/reservations/availability/${date}`);
    return response.data;
  },

  // Create Reservation (Admin)
  createReservation: async (reservationData) => {
    const response = await api.post('/reservations/', reservationData);
    return response.data;
  },

  // Update Reservation Status (Admin)
  updateReservationStatus: async (reservationId, status, additionalData = {}) => {
    const response = await api.patch(`/reservations/${reservationId}`, {
      status,
      ...additionalData
    });
    return response.data;
  },

  // Assign Table to Booking Request (Admin)
  assignTableToRequest: async (requestId, tableId) => {
    const response = await api.patch(`/reservations/${requestId}/assign-table`, {
      table_id: tableId,
      status: 'confirmed'
    });
    return response.data;
  }
};

